'use client';

import { appDownloadUrl, appendShareParams, telegramBotUrl } from '@repo/config';
import { useTranslations } from 'next-intl';
import { QRCodeSVG } from 'qrcode.react';
import { Container } from '../container';
import { Link } from '../link';
import { AppStoreBadgeRow } from './app-store-badge-row';

interface IDownloadCtaProps {
  heading?: string;
  subheading?: string;
}

export function DownloadCta({ heading, subheading }: IDownloadCtaProps): React.JSX.Element {
  const t = useTranslations('home.download');
  const downloadUrl = appendShareParams(appDownloadUrl, {
    source: 'web',
    campaign: 'app_download',
  });
  return (
    <div className="mx-2 mt-2 mb-2 rounded-4xl bg-gray-950 py-24 sm:py-32">
      <Container>
        <div className="flex flex-col items-start gap-12 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-xl">
            <h2 className="text-4xl font-medium tracking-tight text-white text-balance sm:text-5xl md:text-6xl">
              {heading ?? t('heading')}
            </h2>
            <p className="mt-6 text-lg text-gray-300">{subheading ?? t('subheading')}</p>
            <div className="mt-10">
              <AppStoreBadgeRow />
            </div>
            <p className="mt-6 text-sm text-gray-400">
              {t.rich('telegram', {
                link: (chunks) => (
                  <Link
                    href={telegramBotUrl}
                    target="_blank"
                    className="font-medium text-white underline underline-offset-2"
                  >
                    {chunks}
                  </Link>
                ),
              })}{' '}
              <span aria-hidden className="inline-block rtl:rotate-180">
                →
              </span>
            </p>
          </div>
          <div className="hidden rounded-3xl bg-card p-5 shadow-2xl md:block">
            <QRCodeSVG value={downloadUrl} size={160} level="M" title={t('qrCaption')} />
            <p className="mt-3 text-center text-xs font-medium text-muted-foreground">
              {t('qrCaption')}
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
}
